// components/DateSelector.jsx
import React, { useEffect, useRef, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import PropTypes from 'prop-types';
import { FiCalendar } from 'react-icons/fi';
import { DateTime } from 'luxon';

const DateSelector = ({
  startDate,
  setStartDate,
  timeZone,
  label = 'Select Start Date',
  enforceMinToday = true,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const datePickerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (datePickerRef.current && !datePickerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  let minDate = null;
  if (enforceMinToday) {
    minDate = DateTime.now().setZone(timeZone).startOf('day').toJSDate();
  }

  return (
    <div className="w-full">
      <label className="text-stone-500 flex items-center mb-1-">{label}</label>
      <div
        onClick={() => setIsOpen(true)}
        className="cursor-pointer flex h-12 relative rounded-md items-center justify-center border border-[#282828]"
      >
        {!startDate && (
          <div className="absolute z-[10] flex items-center justify-between w-full px-4 text-[#1E3271]">
            <div>Select Date</div>
            <FiCalendar size={20} />
          </div>
        )}
        <div ref={datePickerRef} className="w-full h-full">
          <DatePicker
            selected={startDate ? new Date(startDate) : null}
            onChange={(date) => setStartDate(date)}
            isClearable={true}
            className="red-border w-full px-2 h-full rounded-md"
            open={isOpen}
            onCalendarClose={() => setIsOpen(false)}
            dateFormat="yyyy-MM-dd"
            minDate={minDate}
            filterDate={(date) => date.getDay() === 5}      // only Fridays allowed
            placeholderText="Select a Friday"                // user hint
          />
        </div>
      </div>
    </div>
  );
};

DateSelector.propTypes = {
  startDate: PropTypes.instanceOf(Date),
  setStartDate: PropTypes.func.isRequired,
  timeZone: PropTypes.string,
  label: PropTypes.string,
  enforceMinToday: PropTypes.bool,
};

export default DateSelector;
